import React, { useState } from 'react';
import { View, TouchableOpacity } from 'react-native';
import { Text } from '../../../globalComponents/NativeOverrides';
import Calendar from 'react-calendar';
import { FilterType } from '../../../store/actions/analyticActions';
import Colors from '../../../constants/Colorsv2';
import moment from 'moment';

type FilterCardProps = { filter: FilterType, onChange:any, onHeightChange:any, loading:boolean }
const FilterCard = ({ filter, onChange, onHeightChange, loading }: FilterCardProps) => {
    const [ calendarActive, setCalendarActive ] = useState(false)
    const [ range, setRange ] = useState({ start_time:moment().subtract(7, 'days'), end_time:moment() })

    const onCalendarChange = (range: Date[]) => {
        let start_time = moment(range[0])
        let end_time = moment(range[1])
        return setRange({ start_time, end_time })
    }

    const onFilterChange = (filter_name:string) => {
        if(loading){ return alert('Hold your horses cowboy while we get data from your previous request.') }
        let quickRange = { start_time:moment().subtract(1, 'days'), end_time:moment() }
        switch(filter_name){
            case 'day': quickRange = { start_time:moment().subtract(1, 'days'), end_time:moment() }; break;
            case 'week': quickRange = { start_time:moment().subtract(7, 'days'), end_time:moment() }; break;
            case 'month': quickRange = { start_time:moment().subtract(30, 'days'), end_time:moment() }; break;
            default: break
        }
        onChange({ ...filter, range: quickRange, active_filter:filter_name })
    }

    const onCustomConfirm = () => {
        setCalendarActive(false); 
        onChange({ ...filter, range, active_filter:'custom' })
    }



    return (
        <View style={{position:'absolute', justifyContent:'flex-start', backgroundColor:calendarActive?`rgba(17,17,17,0.5)`:'transparent', top:0, right:0, left:0, bottom:calendarActive?0:undefined, padding:5, paddingTop:0 }}>
            <View style={{ borderRadius:8, margin:5, marginTop:5, backgroundColor:calendarActive?Colors.shades.white:Colors.shades.shade200 }}>
                <View style={{ padding:16, borderRadius:8 }} onLayout={(ev) => onHeightChange(ev.nativeEvent.layout.height)}>
                    <Text size={16} color={Colors.brand.midnight} weight='semibold'>Select Date Range</Text>
                    <View style={{flexDirection:'row', alignItems:'center', justifyContent:'space-between', marginTop:8}}>
                        <TouchableOpacity onPress={() => onFilterChange('day')}>
                            <Text size={14} weight={filter.active_filter ==='day'?'semibold':'regular'} color={Colors.brand.electric} textAlign='center'>Today</Text>
                        </TouchableOpacity>
                        <TouchableOpacity onPress={() => onFilterChange('week')}>
                            <Text size={14} weight={filter.active_filter ==='week'?'semibold':'regular'} color={Colors.brand.electric} textAlign='center'>Last 7 Days</Text>
                        </TouchableOpacity >
                        <TouchableOpacity onPress={() => onFilterChange('month')}>
                            <Text size={14} weight={filter.active_filter ==='month'?'semibold':'regular'} color={Colors.brand.electric} textAlign='center'>Last 30 Days</Text>
                        </TouchableOpacity>
                        <TouchableOpacity onPress={() => setCalendarActive(!calendarActive)}>
                            <Text size={14} weight={filter.active_filter ==='custom'?'semibold':'regular'} color={Colors.brand.electric} textAlign='center'>Custom</Text>
                        </TouchableOpacity>
                    </View>
                    {filter.active_filter === 'custom' ?
                    <View style={{flex:1, paddingTop:12, paddingBottom:0, flexDirection:'row'}}>
                        <View style={{flex:1, marginRight:15}}>
                            <Text size={12} weight='regular' color={Colors.brand.midnight}>From</Text>
                            <Text style={{ backgroundColor:Colors.shades.shade100, padding:12, borderRadius:8, marginTop:4 }} size={14} weight='semibold' color={Colors.brand.midnight}>{filter.range.start_time.format('MM/DD/YYYY')}</Text>
                        </View>
                        <View style={{flex:1, marginLeft:15}}>
                            <Text size={12} weight='regular' color={Colors.brand.midnight}>To</Text>
                            <Text style={{ backgroundColor:Colors.shades.shade100, padding:12, borderRadius:8, marginTop:4 }} size={14} weight='semibold' color={Colors.brand.midnight}>{filter.range.end_time.format('MM/DD/YYYY')}</Text>
                        </View>
                    </View>
                    :<></>}
                </View>
                {calendarActive ?
                <View>
                    <View style={{justifyContent:'center', alignItems:'center'}}>
                        <Calendar selectRange={true} onChange={(props) => onCalendarChange(props)}  />
                    </View>
                    <View style={{flex:1, padding:18, paddingTop:10, paddingBottom:0, flexDirection:'row'}}>
                        <View style={{flex:1, marginRight:15}}>
                            <Text size={12} weight='regular' color={Colors.brand.midnight}>From</Text>
                            <Text style={{ backgroundColor:Colors.shades.shade100, padding:12, borderRadius:8, marginTop:4 }} size={14} weight='semibold' color={Colors.brand.midnight}>{range.start_time.format('MM/DD/YYYY')}</Text>
                        </View>
                        <View style={{flex:1, marginLeft:15}}>
                            <Text size={12} weight='regular' color={Colors.brand.midnight}>To</Text>
                            <Text style={{ backgroundColor:Colors.shades.shade100, padding:12, borderRadius:8, marginTop:4 }} size={14} weight='semibold' color={Colors.brand.midnight}>{range.end_time.format('MM/DD/YYYY')}</Text>
                        </View>
                    </View>
                    <View style={{flexDirection:'row', alignItems:'center', padding:18, paddingTop:10}}>
                        <TouchableOpacity style={{ flex:1, marginRight:5, borderRadius:4, borderWidth:1, borderColor:Colors.brand.electric, padding:12 }} onPress={() => setCalendarActive(false) }>
                            <Text size={14} color={Colors.brand.electric} textAlign='center' weight='semibold'>Cancel</Text>
                        </TouchableOpacity>
                        <TouchableOpacity style={{ flex:1, marginLeft:5, borderRadius:4, backgroundColor:Colors.brand.electric, padding:12 }} onPress={() => onCustomConfirm()}>
                            <Text size={14} color={Colors.shades.white} textAlign='center' weight='semibold'>Confirm</Text>
                        </TouchableOpacity>
                    </View>
                </View>
                :<></>}
            </View>
            <TouchableOpacity style={{flex:1}} onPress={() => setCalendarActive(!calendarActive)}/>
        </View>
    )
}

export default FilterCard